import axios from "axios"

export default {
    async SystemMailKey() {
        const response = await axios.get('/api/systemdata/systemmailkey/list/select')
        return response
    },
    async FuelBrand() {
        const response = await axios.get('/api/systemdata/fuelbrand/list/select')
        return response
    },
    async Country() {
        const response = await axios.get('/api/systemdata/country/list/select')
        return response
    },
    async Region() {
        const response = await axios.get('/api/systemdata/region/list/select')
        return response
    },
    async Province() {
        const response = await axios.get('/api/systemdata/province/list/select')
        return response
    },
    async ProvinceByCountry(id) {
        const response = await axios.get(`/api/systemdata/province/list/select/bycountry/${id}`)
        return response
    },
    async District(data) {
        const response = await axios.get(`/api/systemdata/district/list/select/${data}`)
        return response
    },
    async Neighborhood(data) {
        const response = await axios.get(`/api/systemdata/neighborhood/list/select/${data}`)
        return response
    },
    async Street(data) {
        const response = await axios.get(`/api/systemdata/street/list/select/${data}`)
        return response
    },
    async LocationType() {
        const response = await axios.get(`/api/systemdata/locationtype/list/select`)
        return response
    },
    async FuelType(data) {
        // If storage request
        if (data && data == 'true' || data == true || data == 'false' || data == false) {
            const response = await axios.get(`/api/systemdata/fueltype/list/select/${data}`)
            return response
        }
        const response = await axios.get('/api/systemdata/fueltype/list/select')
        return response
    },
    async EmissionType() {
        const response = await axios.get('/api/systemdata/emissiontype/list/select')
        return response
    },
    async MeauserementUnit() {
        const response = await axios.get('/api/systemdata/measurementunit/list/select')
        return response
    },
    async Colour() {
        const response = await axios.get('/api/systemdata/colour/list/select')
        return response
    },
    async Sector() {
        const response = await axios.get('/api/systemdata/sectortype/list/select')
        return response
    },
    async TaxAdministrationList() {
        const response = await axios.get('/api/systemdata/taxadministration/list/select')
        return response
    },
    async CommunicationLanguage() {
        const response = await axios.get('/api/systemdata/communicationlanguage/list/select')
        return response
    },
    async OccupationTitle() {
        const response = await axios.get('/api/systemdata/occupationtitle/list/select')
        return response
    },
    async OccupationTitlePrefix(prefix) {
        const response = await axios.get(`/api/systemdata/occupationtitle/list/select/${prefix}`)
        return response
    },
    async FirmContactType() {
        const response = await axios.get('/api/systemdata/firmcontacttype/list/select')
        return response
    },
    async DataType() {
        const response = await axios.get('/api/systemdata/companysystemconstantdatatype/list/select')
        return response
    },
    async Blood() {
        const response = await axios.get('/api/systemdata/bloodtype/list/select')
        return response
    },
    async MaritialStatus() {
        const response = await axios.get('/api/systemdata/maritialstatus/list/select')
        return response
    },
    async RelationDegree() {
        const response = await axios.get('/api/systemdata/employeerelationdegree/list/select')
        return response
    },
    async CurrencyUnit() {
        const response = await axios.get('/api/systemdata/currencyunit/list/select')
        return response
    },
    async VisaType() {
        const response = await axios.get('/api/systemdata/visatype/list/select')
        return response
    },
    async DriverLicenseClass() {
        const response = await axios.get('/api/systemdata/driverlicenseclass/list/select')
        return response
    },
    async DraftOfferPriceChangeRequestStatus() {
        const response = await axios.get('/api/systemdata/draftofferpricechangerequeststatus/list/select')
        return response
    },
    async SalaryType() {
        const response = await axios.get('/api/systemdata/salarytype/list/select')
        return response
    },
    async CollarStatus() {
        const response = await axios.get('/api/systemdata/collarstatus/list/select')
        return response
    },
    async TrafficFine() {
        const response = await axios.get('/api/systemdata/trafficfine/list/select')
        return response
    },
    async TrafficFineByDate(date) {
        const response = await axios.get(`/api/systemdata/trafficfine/list/select/${date}`)
        return response
    },
    async LevyOfficeList() {
        const response = await axios.get('/api/systemdata/levyoffice/list/select')
        return response
    },
    async University() {
        const response = await axios.get('/api/systemdata/university/list/select')
        return response
    },
    async UniversityDepartment(data) {
        const response = await axios.get(`/api/systemdata/universitydepartment/list/select/${data}`)
        return response
    },
    async EducationStatus() {
        const response = await axios.get('/api/systemdata/educationstatus/list/select')
        return response
    },
    async MilitaryTitle() {
        const response = await axios.get('/api/systemdata/militarytitle/list/select')
        return response
    },
    async GetHolidays() {
        const response = await axios.get('/api/systemdata/holidays/list')
        return response
    },
    LevyOffice: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/levyoffice/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/levyoffice/update' : '/api/systemdata/levyoffice/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/levyoffice/delete/${id}`)
            return response
        },
    },
    TaxAdministration: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/taxadministration/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/taxadministration/update' : '/api/systemdata/taxadministration/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/taxadministration/delete/${id}`)
            return response
        },
    },
    ProvinceOperations: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/province/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/province/update' : '/api/systemdata/province/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/province/delete/${id}`)
            return response
        },
    },
    DistrictOperations: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/district/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/district/update' : '/api/systemdata/district/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/district/delete/${id}`)
            return response
        },
    },
    NeighborhoodOperations: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/neighborhood/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/neighborhood/update' : '/api/systemdata/neighborhood/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/neighborhood/delete/${id}`)
            return response
        },
    },
    StreetOperations: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/street/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/street/update' : '/api/systemdata/street/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/street/delete/${id}`)
            return response
        },
    },
    async MuhasabePlani() {
        const response = await axios.get('/api/systemdata/select/list/muhasebeplani')
        return response
    },
    async BankaPlani() {
        const response = await axios.get('/api/systemdata/select/list/bankaplani')
        return response
    },
    async BankaOdemeType() {
        const response = await axios.get('/api/systemdata/select/list/bankaodemetype')
        return response
    },
    async KasaHesapPlaniType() {
        const response = await axios.get('/api/systemdata/select/list/kasahesapplanitype')
        return response
    },
    ProvinceIndexCategory: {
        async Table(data) {
            const response = await axios.post('/api/systemdata/provinceindexcategory/table', data)
            return response
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? '/api/systemdata/provinceindexcategory/update' : '/api/systemdata/provinceindexcategory/create', data)
            return response
        },
        async Delete(id) {
            const response = await axios.post(`/api/systemdata/provinceindexcategory/delete/${id}`)
            return response
        },
        async List() {
            const response = await axios.get(`/api/systemdata/provinceindexcategory/list/select`)
            return response
        },
        async IndexesTable(data) {
            const response = await axios.post('/api/systemdata/province/indexes/table', data)
            return response
        }
    },
    async FuelOrderStatusList() {
        const response = await axios.get('/api/systemdata/fuelorderstatus/list')
        return response
    },
    async TrafikCezasiYansitmaMerkeziType() {
        const response = await axios.get('/api/systemdata/netsistrafikcezasiyansitmamerkezitype/list')
        return response
    },
    async TrafficFinePaymentPlace() {
        const response = await axios.get('/api/systemdata/select/list/trafficfinepaymentplace')
        return response

    },
    async VehiclePlate() {
        const response = await axios.get('/api/vehicleoperations/vehicleplate/select/listall')
        return response
    }
}